"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var base_1 = require("@bhtp-client-api/base");
var AcknowledgementSelectorComponent = (function () {
    function AcknowledgementSelectorComponent() {
        this.acknowledgementAccepted = new core_1.EventEmitter();
        this.acknowledgementUnaccepted = new core_1.EventEmitter();
        this.message = '';
        this.isYesSelected = null;
        this.wasYesSelected = false;
    }
    AcknowledgementSelectorComponent.prototype.ngAfterContentInit = function () {
        if (this.acknowledgement && this.acknowledgement.message) {
            this.message = this.acknowledgement.message;
        }
    };
    AcknowledgementSelectorComponent.prototype.noClicked = function () {
        this.isYesSelected = false;
        this.updateAcknowledgementAcceptanceStatus(this.wasYesSelected, this.isYesSelected);
    };
    AcknowledgementSelectorComponent.prototype.yesClicked = function () {
        this.isYesSelected = true;
        this.updateAcknowledgementAcceptanceStatus(this.wasYesSelected, this.isYesSelected);
        // track whether yes was originally selected/accepted for the next click..
        this.wasYesSelected = this.isYesSelected;
    };
    AcknowledgementSelectorComponent.prototype.updateAcknowledgementAcceptanceStatus = function (wasYesSelected, isYesSelected) {
        if (wasYesSelected && !isYesSelected) {
            // 'yes' was checked, but now it isn't.  fire the callback, if one exists.
            this.acknowledgementUnaccepted.emit(this.acknowledgement);
        }
        else if (!wasYesSelected && isYesSelected) {
            // 'yes was not selected, but now it is.  fire the callback, if one exists.
            this.acknowledgementAccepted.emit(this.acknowledgement);
        }
    };
    return AcknowledgementSelectorComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", base_1.ApiAcknowledgement)
], AcknowledgementSelectorComponent.prototype, "acknowledgement", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AcknowledgementSelectorComponent.prototype, "acknowledgementAccepted", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], AcknowledgementSelectorComponent.prototype, "acknowledgementUnaccepted", void 0);
AcknowledgementSelectorComponent = __decorate([
    core_1.Component({
        selector: 'acknowledgement-selector',
        template: "<div class=\"selector\">     <error-message-display [message]=\"message\"></error-message-display>     <div class=\"checkboxes\">         <label>             <input type=\"checkbox\" [checked]=\"isYesSelected === true\" (change)=\"yesClicked()\" />             YES         </label>         <label>             <input type=\"checkbox\" [checked]=\"isYesSelected === false\" (change)=\"noClicked()\" />             NO         </label>     </div> </div>",
        styles: ["\n        .selector {\n            width: 100%;\n            display: inline-block;\n        }\n\n        .checkboxes {\n            padding-left: 38px;\n        }\n\n        .checkboxes > label {\n            margin-right: 15px;\n            margin-top: 10px;\n            font-size: 18px;\n            font-family: 'Abel',sans-serif;\n            cursor: pointer;\n        }\n\n        .checkboxes > label > input[type=checkbox] {\n            vertical-align: middle;\n            margin: 0;\n            height: 16px;\n            width: 16px;\n            cursor: pointer;\n        }\n    "]
    }),
    __metadata("design:paramtypes", [])
], AcknowledgementSelectorComponent);
exports.AcknowledgementSelectorComponent = AcknowledgementSelectorComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/acknowledgements/acknowledgement-selector.component.js